import { useRef } from 'react';
import { Modal, Text } from '@shopify/polaris';

export default function LabelPreview({html, title, filename, onClose}: {html: string; title: string; filename: string; onClose: () => void}) {
  const frame = useRef<HTMLIFrameElement>(null);
  const download = () => {
    const url = URL.createObjectURL(new Blob([html], {type: 'text/html;charset=utf-8'}));
    const link = document.createElement('a'); link.href = url; link.download = filename; link.click();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  };
  return <Modal open onClose={onClose} title={title} size="large" primaryAction={{content:'Print', onAction:() => frame.current?.contentWindow?.print()}}
    secondaryActions={[{content:'Download printable page', onAction:download}]}><Modal.Section>
    <Text as="p">Print at actual size. If printing is blocked, download the page, open it in your browser, then print.</Text>
    <iframe ref={frame} title={title} srcDoc={html} sandbox="allow-same-origin allow-modals" style={{width:'100%',height:'60vh',border:0}}/>
  </Modal.Section></Modal>;
}
